import { render, staticRenderFns } from "./LogoTop.vue?vue&type=template&id=d98db210&"
import script from "./LogoTop.vue?vue&type=script&lang=js&"
export * from "./LogoTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports